import styled from "styled-components";
import { Alert as DEPRECATED_COMPLIBALERT } from "@songtradr/component-library";
import { staticText } from "../../statics/static-text";

// TEXT
export const text = staticText.components.alertMessage;

// STYLES
export const AlertContainer = styled(DEPRECATED_COMPLIBALERT)<{
  $topMargin?: boolean;
}>`
  margin-top: ${({ $topMargin }) => ($topMargin ? "2.5rem" : undefined)};
`;

// DATA

// TYPES
export type Props = {
  isFormValid?: boolean;
  errorMessage?: string;
  successMessage?: string;
  infoMessage?: string;
  topMargin?: boolean;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
